export enum GlobalEngagementSubmissionDocumentStatus {
    DRAFT = "Draft",
    COMPLETED = "Completed",
    DISCONTINUED = "Discontinued",
    COMPLETED_ADMIN = "Completed Admin"    
}

// Mapper for submission IDs
export const GlobalEngagementSubmissionStatusMapper: Record<GlobalEngagementSubmissionDocumentStatus, number> = {
    [GlobalEngagementSubmissionDocumentStatus.DRAFT]: 1,
    [GlobalEngagementSubmissionDocumentStatus.COMPLETED]: 2,
    [GlobalEngagementSubmissionDocumentStatus.DISCONTINUED]: 3,
    [GlobalEngagementSubmissionDocumentStatus.COMPLETED_ADMIN]: 4,
};